import { SignalsObjectType } from "../SignalsModels";

/** The most charts, tables and unique cards a dashboard can hold. */
export const MAX_DASHBOARD_CHARTS = 20;

/** Charts, tables and unique cards all count toward a dashboard's chart limit. */
export const countsTowardChartLimit = (objectType: SignalsObjectType) =>
    objectType === SignalsObjectType.Chart ||
    objectType === SignalsObjectType.Table ||
    objectType === SignalsObjectType.Unique;
